import React from 'react'
import 'materialize-css'

import { Card, Row, Col, Button } from 'react-materialize'
import { EsitoResume } from './EsitoResume'
import { EsitoButtons } from './EsitoButtons'

export const EsitoError = ({datiRichiesta, idCart}) => {
    return (
        <Card>
            <Row>
                <Col s={12}>
                    <h4>Pagamento non effettuato</h4>
                    <p>Si é verificato un errore nell'esecuzione dei seguenti pagamenti:</p>
                    <EsitoResume datiRichiesta={datiRichiesta} />
                    <p><b>NB:</b> se si tratta di un secondo tentativo a seguito di errore o di procedura annullata è probabile che la pendenza sia ancora in stato "PAGAMENTO IN CORSO".<br />Si consiglia di aspettare qualche minuto o effettuare il pagamento in un secondo momento.</p>
                </Col>
            </Row>
            <EsitoButtons idCart={idCart} />
        </Card>
    );
}